export const ExternalLinkConstants = {
    DEDICATED_STATUS_HUNTER: 'https://www.natshoot.co.za/deddicated-status-practical-targets/',
    DEDICATED_STATUS_SPORTPERSON: 'https://www.natshoot.co.za/deddicated-status-practical-targets/',
    DEDICATED_STATUS_HUNTER_AND_SPORTPERSON: 'https://www.natshoot.co.za/deddicated-status-practical-targets/',
}